var nurseslounge_thoughtLeaders_home = {
    init:function($params){
        $params = $.extend({},$params, {typeName:'thoughtLeaders', tab:'init'});
        nurseslounge_thoughtLeaders_home.lounges_home_first_load($params);
        nurseslounge_lounge_overview.information_lounge_get('init', $params, function($data) {
            nurseslounge_lounges_home.lounge_home_create_lounge($params, $data);
        });
        nurseslounge_lounges_home.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_lounges_home.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
    },
    lounges_home_first_load:function($params){
        var $loungeHomeLeft = $("#nurseslounge-lounges-home .nurseslounge-lounges-home-left");
        var $loungeForm = $loungeHomeLeft.find('form');
        var $name = $loungeForm.find('input[name="name"]');
        //var $states = $loungeForm.find('select[name="states"]');
        var $specialties = $loungeForm.find('select[name="specialties"]');
        var $search = $loungeForm.find('.search');
        var $reset = $loungeForm.find('.reset');
        var $bindingSelector;
        /*
        try{
            $states.chosen('destroy');
        }catch (e) {}
        $states.chosen();
        $states.unbind();
        */
        try{
            $specialties.chosen('destroy');
        }catch (e) {}
        $specialties.chosen();
        $specialties.unbind();
        nurseslounge_thoughtLeaders_home.lounges_home_autocomplete(
            $name,
            $params,
            "/lounges/home/autocomplete",
            function($keyword){
                nurseslounge_thoughtLeaders_home.lounges_home_search($params);
            }
        );
        $specialties.change(function(){
            try {
                clearTimeout($bindingSelector);
            }catch (e) {
            }
            $bindingSelector = setTimeout(function(){
                nurseslounge_lounges_home.lounges_home_search($params);
            }, 800);
        });
        /*
        $states.change(function(){
            try {
                clearTimeout($bindingSelector);
            }catch (e) {
            }
            $bindingSelector = setTimeout(function(){
                nurseslounge_lounges_home.lounges_home_search($params);
            }, 800);
        });
         */
        $search.unbind().click(function(){
            nurseslounge_thoughtLeaders_home.lounges_home_search($params);
        });
        $reset.unbind().click(function(){
            $loungeForm[0].reset();
            $specialties.find('option').prop('selected',false);
            /*
            $states.find('option').prop('selected',false);
             */
            nurseslounge_thoughtLeaders_home.lounges_home_search($params);
        });
        nurseslounge_thoughtLeaders_home.lounges_home_search($params);

        /*Popup Button*/
        var $loungeHomeRight = $("#nurseslounge-lounges-home .nurseslounge-lounges-home-right");
        var $thoughtLeaderContainer = $loungeHomeRight.find(".thought-leader-container");
        var $thoughtLeaderButton = $thoughtLeaderContainer.find(".thought-leader");
        $thoughtLeaderButton.unbind().click(function(){
            nurseslounge_myDashboard_thoughtLeadersForm.open_modal($params);
        });
    },
    lounges_home_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    lounges_home_search:function($params){
        var $loungeHomeLeft = $("#nurseslounge-lounges-home .nurseslounge-lounges-home-left");
        var $loungeForm = $loungeHomeLeft.find('form');
        var $name = $loungeForm.find('input[name="name"]');
        var $specialties = $loungeForm.find('select[name="specialties"]');
        /*
        var $states = $loungeForm.find('select[name="states"]');
         */
        var $loungeList = $loungeHomeLeft.find(".lounge-list:first");
        var $loungeListPreview = nurseslounge_thoughtLeaders_home.lounge_preview();
        var $resultInfo = $loungeHomeLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $loungeHomeLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        $params = $.extend({},$params,{
            name:$name.val(),
            //states:$states.val(),
            specialties:$specialties.val()
        });
        $resultInfo.addClass('nurseslounge-lounge-home-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-lounge-home-preload').html($paginationNavPreview);
        $loungeList.html($loungeListPreview).promise().done(function(){
            nurseslounge_thoughtLeaders_home.lounge_pagination($params);
        });
    },
    lounge_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=10; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4 nurseslounge-lounge-home-preload">' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="lounge-name nurseslounge-lounge-home-preload">' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h4>' +
                '                    <p class="lounge-followers nurseslounge-lounge-home-preload">' +
                '                       &nbsp;' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '            <div class="clg-rating">' +
                '                <div class="rating-stars mb-1">' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                </div>' +
                '                <div class="rating-count text-center text-sm-right nurseslounge-lounge-home-preload">' +
                '                   &nbsp;' +
                '                </div>' +
                '            </div>' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    lounge_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $loungeHomeLeft = $("#nurseslounge-lounges-home .nurseslounge-lounges-home-left");
        var $loungeList = $loungeHomeLeft.find(".lounge-list:first");
        var $paginationNav = $loungeHomeLeft.find('.pagination-nav');
        var $previewHeight = $loungeHomeLeft.find('.lounge-list .preview:first').innerHeight();
        var $loungeHeight = $loungeList.innerHeight();
        var $pageSize = Math.round(($loungeHeight/$previewHeight));
        var $resultInfo = $loungeHomeLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('lounge_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: $pageSize,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource: window.location.protocol +'//'+ window.location.hostname + "/lounges/home/get",
            locator: 'data.lounges',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$params,
                beforeSend: function() {
                    $loungeList.html(nurseslounge_thoughtLeaders_home.lounge_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                var $title = 'Thought Leaders';
                if($loungeList.length > 0 && $loungeList.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$loungeList.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-lounge-home-preload');
                $resultInfo.removeClass('nurseslounge-lounge-home-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">'+$title+'</span>');
                var $chtml = nurseslounge_thoughtLeaders_home.lounge_home_item_html($data);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $loungeList.html('').html($chtml).promise().done(function () {
                        nurseslounge_thoughtLeaders_home.lounges_home_list_events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('lounge_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_thoughtLeaders_home.lounge_pagination($params);
            }else{
                clearTimeout($reload);
            }
        }, 150000);
    },
    lounge_home_item_html:function($lounges){
        var $chtml = '';
        var $userId = libs.memoryGet('user_id');
        $.each($lounges, function($i, $v){
            var $img = $v.logo_root_lounge;
            var $publicLink = $v.public_link;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-key="'+$v.key+'" data-public_link="'+$publicLink+'">' +
                '    <div class="row open-lounge">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4">' +
                '                     <img src="'+$img+'?resize=80" alt="lounge">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="lounge-name">' +
                '                         <a href="javascript:void(0)">'+$v.name+'</a>' +
                '                    </h4>';
            if($v.lounge_type_id != 1 && $v.lounge_type_id != 2){
                $chtml+='' +
                    '<p class="lounge-followers">' +
                    $v.followers_count+ ' Followers' +
                    '</p>';
            }
            $chtml+='' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">';
            if($v.lounge_type_id == 1 || $v.lounge_type_id == 2){
                $chtml+='' +
                    '            <div class="clg-rating">' +
                    '                <div class="rating-stars mb-1">' +
                    nurseslounge_thoughtLeaders_home.add_stars($v.rating) +
                    '                </div>' +
                    '                <div class="rating-count text-center text-sm-right">' +
                    $v.rating + ' / 5 ' +
                    '                </div>' +
                    '            </div>';
            }else{
                $chtml+='' +
                    '            <div class="clg-rating">' +
                    '                <div class="rating-stars mb-1">' +
                    '                   &nbsp;&nbsp;&nbsp;&nbsp;' +
                    '                </div>' +
                    '                <div class="rating-count text-center text-sm-right">' +
                    '                   &nbsp;&nbsp;&nbsp;&nbsp;' +
                    '                </div>' +
                    '            </div>';
            }
            if($userId != 'guest' && $v.lounge_type_id != 1 && $v.lounge_type_id != 2){
                if($v.my_follow) {
                    $chtml +='<button type="button" class="btn btn-light follow-action follow">Followed</button>';
                }else{
                    $chtml+='<button type="button" class="btn btn-save btnAnimate follow-action">Follow</button>';
                }
            }
            $chtml+='' +
                '        </div>' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    lounges_home_list_events:function($params){
        var $loungeHomeLeft = $("#nurseslounge-lounges-home .nurseslounge-lounges-home-left");
        var $loungeList = $loungeHomeLeft.find(".lounge-list:first");
        var $userId = libs.memoryGet('user_id');
        $loungeList.find(".follow-action").unbind().click(function($e){
            $e.stopPropagation();
            var $that = $(this);
            var $follow = !$that.hasClass('follow');
            var $item = $that.parents('.item:first');
            var $key = $item.data('key');
            var $params = {user_id:$userId, key:$key, follow:$follow};
            nurseslounge_lounges_home.lounges_home_list_follower_request($params, function($data){
                if($data.status == 'success'){
                    var $follow = $data.data.follow;
                    var $members = $data.data.members;
                    $item.find('.lounge-followers:first').html($members+ ' Followers');
                    if($follow){
                        $item.find('.follow-action').removeClass('btn-save').removeClass('btnAnimate').addClass('btn-light').addClass('follow').html('Followed');
                    }else{
                        $item.find('.follow-action').removeClass('btn-light').removeClass('follow').addClass('btn-save').addClass('btnAnimate').html('Follow');
                    }
                }
            });
        });
        $loungeList.find(".open-lounge").unbind().click(function(){
            var $key = $(this).parents('.item:first').data('key');
            var $publicLink = $(this).parents('.item:first').data('public_link');
            if($userId == 'guest'){
                window.open($publicLink,'_self');
            }else{
                router.navigate('/thoughtLeaders/'+$key);
            }
        });
    },
};
